import mitt, { Emitter } from 'mitt';

import type { RemoteScrollingPayload } from '@features/Remote/Interaction/setScroll';
import { AppointmentStateItem } from '@src/types/appointment';

enum EventTypes {
  RemoteBasketUpdated = 'remoteBasketUpdated',
  RemoteScrolling = 'remoteScrolling',
  RemotePresentationSlide = 'remotePresentationSlide',
  RemoteStateChanged = 'remoteStateChanged',
  RemoteNavigation = 'remoteNavigation',
  RemoteLeftAppointment = 'remoteLeftAppointment',
  RemoteConnectionRestored = 'remoteConnectionRestored',
}

type Events = {
  [EventTypes.RemoteBasketUpdated]: boolean;
  [EventTypes.RemoteScrolling]: RemoteScrollingPayload;
  [EventTypes.RemotePresentationSlide]: string;
  [EventTypes.RemoteStateChanged]: AppointmentStateItem;
  [EventTypes.RemoteNavigation]: string;
  [EventTypes.RemoteLeftAppointment]: undefined;
  [EventTypes.RemoteConnectionRestored]: undefined;
};

// This is a bit of a test, and the only way I could
// get access to the refetch functionality for the
// basket query since adding the basket hook to
// useAppointmentContext would cause errors.
// If we decide on a better approach in the relevant ticket
// (https://linear.app/utilitywarehouse/issue/AQ-4729/discovery-use-focus-interaction-events-to-synchronise-accordions-and)
// then we can dispose of or repurpose this
const emitter: Emitter<Events> = mitt<Events>();

export { emitter, EventTypes };
export type { Events };
